import { MainLayout } from 'components/layouts/MainLayout';
import { FC } from 'types/global';
import { LoadHeaderAdmin } from 'components/grid/headers/LoadHeaderAdmin';

export const LoadLayoutAdmin: FC<object> = ({ children }) => {
  return <MainLayout Header={LoadHeaderAdmin}>{children}</MainLayout>;
};
